import { useEffect, useState } from "react";
import { functionService } from "../../../lib/functions";
import Header from "../../../components/header";
import ArticleDropdown from "../../../components/elements/articleDropdown";
import * as Styled from "./styled";

import editIcon from "../../../images/edit.svg";
import deleteIcon from '../../../images/delete.svg';
import upvoteIcon from '../../../images/upvote.svg'
import downvoteIcon from '../../../images/downvote.svg'
import shareIcon from '../../../images/share.svg';
import commentIcon from '../../../images/comment.svg';
import { Select } from "antd";
import { DatePicker, Space } from 'antd';
import moment from "moment/moment";


const ListArticles = () => {
  const [articleData, setArticleData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchCategory, setSearchCategory] = useState('');
  const [searchType, setSearchType] = useState('');
  const [publishChange, setPublishChange] = useState(true);
  const [sortBy, setSortBy] = useState('created_at');
  const [statusChange,setStatusChange]=useState('')
  const { RangePicker } = DatePicker;
  const [startDate,setStartDate]=useState('')
  const [endDate,setEndDate]=useState('')
  // const [checked, setChecked] = useState(false);

  useEffect(() => {
    functionService.get('article/getArticleCategories')
    .then(response => setCategories(response.response.data.data));
  },[])
  useEffect(() => {
    functionService.post(`article/getAllArticle`, {category: searchCategory, type: searchType, sortBy,status:statusChange==='Published'?true:statusChange===''?'':false,startDate:startDate?startDate:'',endDate:endDate?endDate:''})
    .then(response => setArticleData(response.response.data.data));
    // console.log('===========>', response)
    // setArticleData(response.data.data);
    // console.log(response.data.data);
  }, [searchCategory, searchType, publishChange, sortBy,statusChange,startDate,endDate]);


  const handleArticleDelete = async (articleId) => {
    functionService.post('article/deleteArticle', {articleId: articleId}).then(response => console.log(response));
    setArticleData(articleData.filter((item) => item.id !== articleId));
  }

  const handleCategoryChange = (item) => {
    setSearchCategory(item);
  }

  const handleTypeChange = (item) => {
    setSearchType(item);
  }

  const handleSortByChange = (item) => {
    setSortBy(sortByList.filter(val => val.name === item)[0]?.sortKey);
  }

  const handlePublishStatusChange = async (articleId, status) => {
    await functionService.post(`article/change-publish-status`, {articleId, status});
    setPublishChange(!publishChange);
  }

  const handleStatusChange=(item)=>{
    setStatusChange(item)
  }
  const sortByList = [
    {name: "Date of Post", sortKey: "created_at"},
    {name: "Comments", sortKey: "comment_count"},
    {name: "Downvotes", sortKey: "downvote_count"},
    {name: "Upvotes", sortKey: "upvote_count"},
    {name: "Shares", sortKey: "share_count"},
    {name: "Title", sortKey: "title"}
  ]
  const statusList=[
    {name:'Published'},{name:'Not Published'}
  ]
  const handleDate=(item)=>{
    setStartDate(moment(item[0]['$d']).utc().format())
    setEndDate(moment(item[1]['$d']).utc().format())

    // console.log(item[0]['$d']);
  }

  const getTag = (tag) => {
    switch (tag) {
      case 'ONGOING':
        return {
          color: '#21C17A',
          backgroundColor: 'rgba(33, 193, 122, 0.1)',
          border: '1px solid #21C17A'
        }
      case 'UPCOMING':
        return {
          color: '#939599',
          backgroundColor: 'rgba(147, 149, 153, 0.1)',
          border: '1px solid #939599'
        }
      case 'DRAFT':
        return {
          color: '#FFA91B',
          backgroundColor: 'rgba(255, 169, 27, 0.1)',
          border: '1px solid #FFA91B'
        }
      case 'EXPIRED':
        return {
          color: '#F1543F',
          backgroundColor: 'rgba(241, 84, 63, 0.1)',
          border: '1px solid #F1543F'
        }
        default:
          break;
    }
  }


  return (
    <Styled.ColumnDiv>
      <Header />
      <Styled.ContentWrapDiv>
        <Styled.ContentDiv>
          <Styled.HeaderWrapDiv>
            <div>
              All Articles
              <p style={{fontSize: '12px', fontWeight: '400'}}>Create, edit and manage all the articles.</p>
            </div>
            {console.log(sortBy)}
            <Styled.AddLink to="/articles/add">
              <span>+</span>Add article
            </Styled.AddLink>
          </Styled.HeaderWrapDiv>
          <div style={{ minHeight: "58px" }}>
            <Styled.FilterWrapDiv>
              <ArticleDropdown
                title="Categories"
                list={categories}
                value="id"
                name="category"
                selected={handleCategoryChange}
                width="180px"
                option="name"
                active={searchCategory}
                addAll
              />
              <ArticleDropdown
                title="Type"
                list={[{title: "Article"},{title: 'Blog'}]}
                value="id"
                name="article_type"
                selected={handleTypeChange}
                width="180px"
                option="title"
                active={searchType}
                addAll
              />
              <ArticleDropdown
                title="Sort By"
                list={sortByList}
                value="id"
                name="sortBy"
                selected={handleSortByChange}
                width="180px"
                option="name"
                active={sortBy}
              />
              <ArticleDropdown
                title="Select Status"
                list={statusList}
                value="id"
                name="status_type"
                selected={handleStatusChange}
                width="180px"
                option="name"
                active={statusChange}
                addAll
                // active={searchType}
              />
              <RangePicker style={{height:"38px",width:"270px"}} onChange={handleDate} />

              {/* <Styled.SearchDiv>
                      <img src={search} alt="search" />
                      <input type="text" placeholder="Search" />
                    </Styled.SearchDiv> */}
            </Styled.FilterWrapDiv>
          </div>
          <Styled.CardDiv>
            {articleData.map((item, idx) => (
              <Styled.TestWrapDiv key = {idx}>
                <Styled.TestImage
                  src={item.banner_img}
                  // onError={({ currentTarget }) => {
                  //   currentTarget.onerror = null;
                  //   currentTarget.src = item.banner_img;
                  // }}
                  alt="Article"
                />
                <Styled.TestColumnDiv style={{ minWidth: '0', margin: '0px 20px' }}>
                  <Styled.TestHeadingP>{item.title}</Styled.TestHeadingP>
                  <p style={{marginTop:"5px",fontWeight:600}}>{`${moment(item.created_at).format('DD')}-${moment(item.created_at).format('MMMM')}-${moment(item.created_at).format('YYYY')}`}</p>
                  <Styled.TestInfoWrapDiv style={{paddingTop: '10px'}}>
                    <div>
                      <img src={commentIcon} alt="comments" />
                      <div>{item?.comment_count || 0}</div>
                    </div>
                    <div>
                      <img src={downvoteIcon} alt="downvotes" />
                      <div>{item?.downvote_count || 0}</div>
                    </div>
                    <div>
                      <img src={upvoteIcon} alt="upvotes" />
                      <div>{item?.upvote_count || 0}</div>
                    </div>
                    <div>
                      <img src={shareIcon} alt="shares" />
                      <div>{item?.share_count || 0}</div>
                    </div>
                  </Styled.TestInfoWrapDiv>
                </Styled.TestColumnDiv>
                <Styled.TestColumnDiv style={{ alignItems: 'flex-end', marginLeft: 'auto', flexShrink: '0' }}>
                <div style={{display: 'flex'}}>
                  <Styled.TagSpan tagStyle={getTag('ONGOING')}>{item?.type || 'Article'}</Styled.TagSpan>
                  <Styled.TagSpan tagStyle={getTag('DRAFT')}>{item?.category || 'All'}</Styled.TagSpan>
                </div>
                    <Styled.TestActionWrapDiv>
                      <Styled.ActionLink to={`/articles/${item.id}`}>
                        <img src={editIcon} alt="edit" title="Edit Article" />
                      </Styled.ActionLink>
                      <Styled.ActionButton>
                        <img src={deleteIcon} alt="delete" title="Delete Article" onClick={() => handleArticleDelete(item.id)}/>
                      </Styled.ActionButton>
                    </Styled.TestActionWrapDiv>
                    <Styled.TestSwitchDiv>
                      <Styled.SwitchLabel><input type="checkbox" checked={item.active} onChange={() => handlePublishStatusChange(item.id, item.active)}/><span /></Styled.SwitchLabel>
                      <div style={{width: '100px'}}>{item.active ? "Published" : "Not Published"}</div>
                    </Styled.TestSwitchDiv>
                </Styled.TestColumnDiv>
              </Styled.TestWrapDiv>
            ))}
          </Styled.CardDiv>
        </Styled.ContentDiv>
      </Styled.ContentWrapDiv>
    </Styled.ColumnDiv>
  );
};

export default ListArticles;
